export default __webpack_public_path__ + "static/media/arrows.af2e11b4.svg";